<template>
  <div id="add-quotation">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Tạo mới báo giá', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter pb-5">
      <block :nobody="true" ref="bqouta" class="soft-control">
        <!-- <b-row align-v="center" class="text-center">
          <b-col><h3 class="mt-3">Báo giá mới</h3></b-col>
        </b-row>
        <hr /> -->
        <b-row class="mx-0" align-h="center">
          <b-col md="10 px-0 border-right border-info">
            <b-card class="m-3">
              <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
                <form role="form" @submit.prevent="handleSubmit(doSave)">
                  <b-row>
                    <b-col>
                      <base-input
                        :disabled="quotation.id != ''"
                        v-model="quotation.code"
                        label="Mã báo giá"
                        placeholder="Không nhập hệ thống sẽ tự phát sinh"
                      >
                      </base-input>
                    </b-col>
                    <b-col>
                      <div>
                        <label for="datepicker-lg">Ngày tạo</label>
                        <b-form-datepicker
                          :disabled="quotation.id != ''"
                          id="datepicker-lg"
                          :date-format-options="{
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          }"
                          v-model="quotation.date"
                          locale="vi"
                        ></b-form-datepicker>
                      </div>
                    </b-col>
                    <b-col>
                      <base-input label="Người Tạo" readonly v-model="info.username"> </base-input>
                    </b-col>
                  </b-row>
                  <fieldset class="border-info my-3">
                    <legend>
                      Thông tin đặt hàng:
                      <b-button size="sm" @click="addNewCustomer" variant="success">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        Tạo mới khách hàng
                      </b-button>
                    </legend>
                    <b-row>
                      <b-col md="4">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                          <base-select
                            :disabled="quotation.id != ''"
                            @change="quotationCustomerChange"
                            v-model="quotation.customer"
                            label="Mã khách hàng"
                            :ajaxData="getCustomer"
                            :error="errors[0]"
                          >
                            <template v-slot:selected="{ item }">
                              <div>
                                {{ item.code }}
                              </div>
                            </template>
                            <template v-slot:body="{ item }">
                              <div>
                                <strong>{{ item.code }}</strong> <br />
                                <span>{{ item.name }}</span>
                              </div>
                            </template>
                          </base-select>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="4">
                        <base-select
                          :disabled="quotation.id != ''"
                          v-model="quotation.customer"
                          label="Tên khách hàng"
                          :ajaxData="getCustomer"
                          ><template v-slot:selected="{ item }">
                            <div>
                              {{ item.name }}
                            </div>
                          </template>
                          <template v-slot:body="{ item }">
                            <div>
                              <strong>{{ item.code }}</strong> <br />
                              <span>{{ item.name }}</span>
                            </div>
                          </template>
                        </base-select>
                      </b-col>
                      <b-col md="4">
                        <base-select
                          :disabled="quotation.id != ''"
                          v-model="quotation.customer"
                          label="Email khách hàng"
                          :ajaxData="getCustomer"
                          ><template v-slot:selected="{ item }">
                            <div>
                              {{ item.email }}
                            </div>
                          </template>
                          <template v-slot:body="{ item }">
                            <div>
                              <strong>{{ item.code }}</strong> <br />
                              <span>{{ item.name }}</span>
                            </div>
                          </template>
                        </base-select>
                      </b-col>
                    </b-row>
                    <hr class="m-1" />
                    <template v-if="quotation.customerContact && quotation.customerContact.id">
                      <b-button @click="addNewCustomerContact" size="sm" pill="">
                        <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                        Thêm mới người liên hệ
                      </b-button>
                      <b-row>
                        <b-col md="3">
                          <base-select
                            :disabled="quotation.id != ''"
                            v-model="quotation.customerContact"
                            label="Tên người liên hệ"
                            :options="quotation.customer.customerContacts"
                          >
                            <template v-slot:selected="{ item }">
                              <div>
                                {{ item.name }}
                              </div>
                            </template>
                            <template v-slot:body="{ item }">
                              <div>
                                <strong>{{ item.name }}</strong>
                                <br />
                                <span>{{ item.email }}</span> <br />
                                Loại :
                                <b-badge variant="primary" v-if="item.type == 'ORDER'">
                                  Người đặt hàng
                                </b-badge>
                                <b-badge variant="success" v-else-if="item.type == 'PAYMENT'">
                                  Người thanh toán
                                </b-badge>
                                <b-badge variant="info" v-else>
                                  Người nhận hàng
                                </b-badge>
                              </div>
                            </template>
                          </base-select>
                        </b-col>
                        <b-col md="3">
                          <base-input label="Email" placeholder="" readonly v-model="quotation.customerContact.email">
                          </base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input
                            label="Địa chỉ"
                            placeholder=""
                            readonly
                            v-model="quotation.customerContact.address"
                          >
                          </base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input
                            label="Điện thoại"
                            placeholder=""
                            readonly
                            v-model="quotation.customerContact.phone"
                          >
                          </base-input>
                        </b-col>
                      </b-row>
                    </template>
                  </fieldset>
                </form>
              </ValidationObserver>
              <hr />
              <div class="d-flex">
                <h5>* Sản phẩm :</h5>
                <b-button
                  v-if="quotation.id == ''"
                  @click="productQuotationAddRow"
                  variant="success px-1 py-0 ml-2 mb-2"
                >
                  <i class="fa fa-flus" aria-hidden="true"></i> Thêm 1 dòng
                </b-button>
              </div>
              <base-table :data="productQuotations">
                <template slot="columns">
                  <th>STT</th>
                  <th>Mã sản phâm</th>
                  <th>Tên sản phẩm</th>
                  <th>Diễn giải</th>
                  <th>Quy cách</th>
                  <th>Chiều dài</th>
                  <th>Hệ màu</th>
                  <th>Màu sắc</th>
                  <th>Mã màu</th>
                  <th>Đơn giá</th>
                  <th v-if="quotation.id == ''">Loại tiền</th>
                  <th>Số lượng từ</th>
                  <th v-if="quotation.id == ''">Đơn vị tính của số lượng</th>
                  <th>Ghi chú</th>
                  <th>Bổ sung</th>
                  <th></th>
                </template>

                <template slot-scope="{ row, index }">
                  <tr v-if="!row.edit" :key="index">
                    <td class="bg-info text-light col-fix ">
                      {{ index + 1 }}
                    </td>
                    <td>{{ row.product.code }}</td>
                    <td>{{ row.product.name }}</td>
                    <!-- <td>{{ row.productCustom }}</td> -->
                    <td>
                      <span v-if="row.reason">{{ row.reason.name }}</span>
                    </td>
                    <td class="text-center">{{ row.productSpecify.name }}mm</td>
                    <td class="text-center">{{ row.length }} mm</td>
                    <td class="text-center">
                      <span v-if="row.color">{{ row.color.label }}</span>
                    </td>
                    <td class="text-center">
                      {{ row.colorText }}
                    </td>
                    <td>{{ row.colorCode }}</td>
                    <td class="text-right">{{ row.price }} {{ row.currency }} / {{ row.unit }}</td>
                    <td class="text-right">{{ row.quantity }} {{ row.unit }}</td>
                    <td>
                      <span>{{ row.note }}</span>
                    </td>
                    <td>
                      <span v-if="row.onlyOnce">Chỉ áp dụng cho đơn hàng này</span>
                    </td>
                    <td class="col-fix text-center">
                      <b-button
                        v-if="row.product && row.product.id && row.productSpecify && row.productSpecify.id"
                        @click="viewHistory(row)"
                        variant="outline-success px-1 py-0"
                      >
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Lịch sử giá
                      </b-button>
                    </td>
                  </tr>
                  <tr v-else :key="index">
                    <td class="bg-info text-light col-fix text-center">
                      {{ index + 1 }}
                    </td>
                    <td class="p-1">
                      <base-select
                        @change="productChange(row)"
                        v-model="row.product"
                        :ajaxData="getProduct"
                        placeholder="Nhập mã hoặc tên sản phẩm"
                        :error="!row.product || !row.product.id"
                      >
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.code }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </td>
                    <td class="p-1">
                      <span v-if="row.product">{{ row.product.name }}</span>
                    </td>
                    <td style="min-width:140px">
                      <base-select
                        class="w-100"
                        @change="reasonChange($event, row)"
                        v-model="row.reason"
                        :ajaxData="getReason"
                      >
                        <template v-slot:selected="{ item }">
                          <div>{{ item.key }} - {{ item.name }}</div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.key }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </td>
                    <td class="p-1">
                      <base-select
                        @change="productSpecifyChange(row)"
                        v-if="row.product && row.product.id"
                        v-model="row.productSpecify"
                        :options="row.product.productSpecifys"
                        :error="!row.productSpecify || !row.productSpecify.id"
                      >
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }} mm
                            <span v-if="item.color && item.color.id"> - {{ item.color.label }} </span>
                            <span> - : {{ $ucWord(item.unit) }}</span>
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <span>{{ item.name }} mm</span>
                            <span v-if="item.color && item.color.id"> - {{ item.color.label }} </span>
                            <span> - : {{ $ucWord(item.unit) }}</span>
                          </div>
                        </template>
                      </base-select>
                      <span v-else>--Vui lòng chọn sản phẩm--</span>
                    </td>
                    <td class="p-1" style="min-width:150px">
                      <div class="d-flex">
                        <base-input
                          :mask="'number'"
                          @change="loadHistoryPrice(row)"
                          placeholder="Ex : 100"
                          v-model="row.length"
                        >
                        </base-input>
                        <span style="vertical-align: middle; align-self: center; margin-left: 5px; margin-top: -8px;"
                          >cm</span
                        >
                      </div>
                    </td>
                    <td class="p-1">
                      <color
                        @change="productColorChange(row)"
                        :error="!row.color || !row.color.id"
                        v-model="row.color"
                      ></color>
                    </td>
                    <td style="min-width:140px">
                      <base-input placeholder="Ex: Hồng phấn" class="mb-0" v-model="row.colorText"> </base-input>
                    </td>
                    <td class="p-1" style="min-width:100px">
                      <base-input class="mb-0" v-model="row.colorCode"> </base-input>
                    </td>
                    <td class="p-1" style="min-width:160px">
                      <base-input
                        :load="!row.loaded"
                        :loadMes="'Đang tải lịch sử giá...'"
                        :mask="'number'"
                        v-model="row.price"
                      >
                      </base-input>
                    </td>
                    <td>
                      <base-select
                        v-model="row.currency"
                        :options="['VND', 'USD']"
                        :error="!row.currency || row.currency == ''"
                      ></base-select>
                      <!-- <base-input
                        placeholder="ex: 100 USD"
                        class="mb-0"
                        v-model="row.currency"
                      >
                      </base-input> -->
                    </td>
                    <td class="p-1">
                      <base-input @keyup="quantityChange(row)" :mask="'number'" v-model="row.quantity"> </base-input>
                    </td>
                    <td>
                      <base-input v-model="row.unit"> </base-input>
                    </td>
                    <td style="min-width:150px">
                      <textarea v-model="row.note"></textarea>
                    </td>
                    <td style="padding-left:35px">
                      <b-checkbox variant="success" v-model="row.onlyOnce" switch value="1">
                        Chỉ áp dụng <br />
                        cho đơn hàng này
                      </b-checkbox>
                    </td>
                    <td class="col-fix text-center">
                      <div class="d-flex">
                        <b-button
                          class="mr-2"
                          variant="outline-danger px-1 py-0"
                          @click="productQuotationDeleteRow(index, row)"
                        >
                          <i class="fa fa-backspace" aria-hidden="true"></i>
                        </b-button>
                        <b-button @click="copyRow(row)" variant="info px-1 py-0">
                          Copy Dòng này
                        </b-button>
                        <div v-if="row.product && row.product.id && row.productSpecify && row.productSpecify.id">
                          <b-button
                            v-if="row.priceHistories.total > 0"
                            @click="viewHistory(row)"
                            variant="outline-success px-1 py-0"
                          >
                            <i class="fa fa-history" aria-hidden="true"></i>
                            Lịch sử giá
                          </b-button>
                          <b-badge v-else>Chưa báo giá</b-badge>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </base-table>
              <hr />
              <div class="form-group" style="overflow: hidden;">
                <label class="form-control-label" for="">Ghi chú</label>
                <ckeditor :editor="editor" v-model="quotation.note" @ready="onReady" :config="editorConfig"></ckeditor>
              </div>
            </b-card>
          </b-col>
          <b-col md="2 px-0">
            <b-card class="m-3 sticky-top">
              <b-row>
                <b-col xl="12" class="mb-2">
                  <b-button @click="handleSave" :disabled="quotation.id != '' && !isEdit" variant="success" block>
                    <i class="fa fa-save" aria-hidden="true"></i>
                    {{ quotation.id != '' ? 'Đã lưu báo giá' : 'Lưu Báo giá' }}
                  </b-button>
                </b-col>
                <b-col xl="12" class="mb-2">
                  <b-button @click="doPrint" variant="primary" block>
                    <i class="fa fa-print" aria-hidden="true"></i>
                    In báo giá
                  </b-button>
                </b-col>
                <b-col xl="12">
                  <b-button @click="doBack" block>
                    <i class="fa fa-long-arrow-alt-left" aria-hidden="true"></i>
                    Trở về
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </block>
      <preview @doSave="handleSaveFromPreview" ref="preview"></preview>
      <customer-modal @submit:success="updateCustomer" ref="customer-modal" />
      <cs-contact-modal @submit:success="updateCustomer" ref="cs-contact-modal" />
      <history ref="history" @choosePrice="handelChoosePrice"></history>
    </div>
  </div>
</template>
<script>
import { customerService, productService, quotaService } from '@/_services';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import CustomerModal from '../Customer/components/CustomerModal';
import CustomerContactModal from '../Customer/components/CustomerContactModal';
import Preview from './__Preview';
import History from './__History';

import { mapState } from 'vuex';

export default {
  name: 'add-quotation',
  components: {
    ckeditor: CKEditor.component,
    Preview,
    CustomerModal,
    'cs-contact-modal': CustomerContactModal,
    History
  },
  computed: {
    ...mapState('user', ['info'])
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      products: [],
      productQuotations: [],
      productQuotationSelect: {},
      quotation: {
        id: '',
        code: '',
        customer: '',
        customerContact: '',
        date: new Date(),
        note:
          '<ul><li>Mức giá trên chưa bao gồm 10% <strong>VAT.</strong></li><li><strong>VAT </strong>10% does not include in this price.</li></ul>'
      },
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          'heading',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'link',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          'bulletedList',
          'numberedList',
          'blockQuote',
          '|',
          'indent',
          'outdent',
          'link',
          'insertTable',
          'tableColumn',
          'tableRow',
          'mergeTableCells'
        ],
        entities: false,
        editorDisabled: false
      },
      back: -1,
      isEdit: false
    };
  },
  created() {
    this.productQuotationAddRow();
  },
  mounted() {
    if (this.$route.query.id_customer) {
      this.$refs.bqouta.block();
      customerService
        .findOne(this.$route.query.id_customer)
        .then(res => {
          this.quotation.customer = res.data;
        })
        .finally(() => {
          this.$refs.bqouta.unBlock();
        });
    }
    if (this.$route.query.copy_id) {
      this.$refs.bqouta.block();
      quotaService
        .findOne(this.$route.query.copy_id)
        .then(res => {
          let quota = res.data;
          this.quotation.customer = quota.customer;
          this.quotation.note = quota.note;
          quota.quotaDetails.forEach(element => {
            delete element.id;
            element.edit = true;
            element.loaded = true;
            element.priceHistories = {
              data: [],
              total: 1
            };
          });
          this.productQuotations = quota.quotaDetails;
          this.back = -2;
        })
        .finally(() => {
          this.$refs.bqouta.unBlock();
        });
    } else if (this.$route.query.edit_id) {
      this.$refs.bqouta.block();
      quotaService
        .findOne(this.$route.query.edit_id)
        .then(res => {
          let quota = res.data;
          this.quotation = quota;
          this.quotation.customer = quota.customer;
          this.quotation.note = quota.note;
          this.isEdit = true;
          quota.quotaDetails.forEach(element => {
            element.edit = true;
            element.loaded = true;
            element.priceHistories = {
              data: [],
              total: 1
            };
          });
          this.productQuotations = quota.quotaDetails;
          this.back = -2;
        })
        .finally(() => {
          this.$refs.bqouta.unBlock();
        });
    }
  },
  methods: {
    fetchData() {},
    getCustomer(keyword, cb) {
      customerService.findAll({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    getProduct(keyword, cb) {
      productService.findAll({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    copyRow(row) {
      const tmp = Object.assign({}, row);
      tmp.id = null;
      this.productQuotations.push(tmp);
    },
    productQuotationAddRow() {
      this.productQuotations.push({
        edit: true,
        product: {},
        productSpecify: {},
        length: '',
        color: '',
        colorCode: '',
        price: 0,
        currency: '',
        colorText: '',
        unit: '',
        note: '',
        quantity: 0,
        onlyOnce: false,
        loaded: false,
        priceHistories: {
          data: [],
          total: 0
        }
      });
    },
    productQuotationDeleteRow(index, item) {
      if (item.edit) {
        this.productQuotations.splice(index, 1);
      } else {
        this.$swal({
          title: 'Bạn có chắc thực hiện thao tác này?',
          text: 'Bạn sẽ không thể hoàn nguyên điều này!!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Không',
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            alert('contact dev');
          }
        });
      }
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    quotationCustomerChange() {
      this.quotation.customerContact = '';
      if (this.quotation.customer && this.quotation.customer.customerContacts) {
        if (this.quotation.customer.customerContacts.length > 0) {
          for (let i = 0; i < this.quotation.customer.customerContacts.length; i++) {
            const element = this.quotation.customer.customerContacts[i];
            if (element.isDefault) {
              this.quotation.customerContact = element;
            }
          }
          if (!this.quotation.customerContact.id)
            this.quotation.customerContact = this.quotation.customer.customerContacts[0];
        }
      }
    },
    addNewCustomer(type = '') {
      this.$refs['customer-modal'].setStep(0);
      this.$refs['customer-modal'].visible = true;
      this.$refs['customer-modal'].setData({}, type);
    },
    updateCustomer() {
      if (this.quotation.customer && this.quotation.customer.customerContacts) {
        // if (this.order.customerContact == "") {
        //   this.order.customerContact = item;
        // }
      }
    },
    addNewCustomerContact() {
      if (!this.quotation.customer || !this.quotation.customer.id) return;
      this.$refs['cs-contact-modal'].visible = true;
      this.$refs['cs-contact-modal'].setData(this.quotation.customer, {
        type: 'ORDER',
        isDefault: true
      });
    },
    validateQuotation() {
      var self = this;
      return new Promise(async (resolve, reject) => {
        let validate = await self.$refs.csInfo.validate();
        self.productQuotations.forEach(item => {
          if (
            !item.product ||
            !item.product.id ||
            !item.productSpecify ||
            !item.productSpecify.id ||
            !item.color ||
            !item.color.id
          ) {
            validate = false;
          }
        });
        if (validate) {
          resolve();
        } else {
          reject();
        }
      });
    },
    async handleSave() {
      await this.validateQuotation()
        .then(async () => {
          await this.doSave();
        })
        .catch(() => {
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    async handleSaveFromPreview(cb) {
      await this.validateQuotation()
        .then(async () => {
          await this.doSave();
          cb();
        })
        .catch(() => {
          cb();
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    productChange(row) {
      row.productSpecify = '';
      row.price = 0;
      row.loaded = false;
    },
    quantityChange(row) {
      row.note = `Áp dụng số lượng từ ${this.$formatNumber(row.quantity)} ${row.unit} trở lên`;
    },
    viewHistory(item) {
      this.productQuotationSelect = item;
      if (!item.productSpecify && !item.product) return;
      let customerId = this.quotation.customer ? this.quotation.customer.id : '';
      this.$refs.history.setData({
        productId: item.product.id,
        specId: item.productSpecify.id,
        color: item.color,
        customerId: customerId
      });
      this.$refs.history.visible = true;
    },
    productSpecifyChange(item) {
      if (item.productSpecify && item.productSpecify.color && item.productSpecify.color.id) {
        item.color = item.productSpecify.color;
        item.unit = item.productSpecify.unit;
        item.colorText = item.color.label;
      } else {
        item.color = '';
      }
      this.loadHistoryPrice(item);
    },
    productColorChange(item) {
      item.colorText = item.color.label;
      this.loadHistoryPrice(item);
    },
    loadHistoryPrice(item) {
      if (!item.productSpecify || !item.product || !item.color) return;
      let customerId = this.quotation.customer ? this.quotation.customer.id : '';
      let query = {
        limit: 10,
        page: 1,
        productId: item.product.id,
        specId: item.productSpecify.id,
        color: item.color.id,
        length: item.length,
        reasonId: item.reasonId,
        customerId: customerId
      };
      item.loaded = false;
      quotaService.history(query).then(res => {
        item.loaded = true;
        item.priceHistories = {
          data: res.data.data,
          total: res.data.total
        };
        if (item.priceHistories.data.length > 0) {
          item.price = item.priceHistories.data[0].price;
        } else {
          item.price = 0;
        }
      });
    },
    handelChoosePrice(price) {
      if (this.productQuotationSelect) {
        if (!this.quotation.id) this.productQuotationSelect.price = price;
      }
    },
    doSave() {
      this.$refs.bqouta.block();
      let quotation = Object.assign({}, this.quotation);
      quotation.customer = {
        id: this.quotation.customer.id
      };
      let productQuotations = [];
      this.productQuotations.forEach(element => {
        let tmp = Object.assign({}, element);
        tmp.product = {
          id: element.product.id
        };
        tmp.productSpecify = {
          id: element.productSpecify.id
        };
        if (tmp.reason) {
          tmp.productCustom = element.reason.name;
        }
        productQuotations.push(tmp);
      });
      quotaService
        .create(quotation, productQuotations)
        .then(res => {
          this.$alertify.success(res.message, {
            duration: 4000
          });
          this.quotation = res.data;
          this.quotation.date = new Date(this.quotation.date);
          this.productQuotations.forEach(element => {
            element.edit = false;
          });
        })
        .finally(() => {
          this.$refs.bqouta.unBlock();
        });
    },
    doPrint() {
      this.validateQuotation()
        .then(() => {
          this.$refs.preview.visible = true;
          this.$refs.preview.setData(this.quotation, this.productQuotations);
        })
        .catch(() => {
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    doBack() {
      var self = this;
      this.$swal({
        title: 'Bạn có chắc thực hiện thao tác này?',
        text: 'Những thao tác bạn vừa thực hiện sẽ không được lưu lại',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Không',
        reverseButtons: true
      }).then(function(result) {
        if (result.value) {
          self.$router.go(self.back);
        }
      });
    },
    getReason(keyword, cb) {
      productService.findReason({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    reasonChange(modal, row) {
      row.reasonId = modal.id;
      this.loadHistoryPrice(row);
    }
  }
};
</script>
<style lang="scss">
.ck-editor__editable {
  min-height: 150px;
}
#add-quotation {
  .soft-control {
    .b-table-sticky-header {
      height: 500px;
      max-height: 500px;
    }
  }
}
</style>
